import Entity from '@/common-utils/components/renders/entity/Entity';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import notifRulesFields from '../../../fields/notifRulesFields';
import RenderApplication from '@/app/modules/contracts/components/application/RenderApplication';
import RenderBankCode from '@/app/modules/contracts/components/bankCode/RenderBankCode';
import DropdownNotifRulesActionsRow from '../../dropdown/DropdownNotifRulesActionsRow';
import { nsNotifRules } from '@/app/i18n/namespaces';

export const columnsNotifRulesId = 'notifRules';

export const columnsNotifRules = (headerPackage) => {

    return ([
        generateColumnDefByField({
            field: notifRulesFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                return (
                    <DropdownNotifRulesActionsRow pushPaymentNotifRule={cell.row.original}
                        setLaunchRefetch={headerPackage.setLaunchRefetch} />
                );
            }
        }),
        generateColumnDefByField({
            field: notifRulesFields.RECIPIENT,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: notifRulesFields.LEGAL_NAME,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: notifRulesFields.PARTNER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: notifRulesFields.CONTRACT,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: notifRulesFields.RANK,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const isRank = cell && cell.getValue() && cell.getValue() !== '*';
                return isRank ?
                    cell.getValue()
                    : <Entity entity={'rank.all'} namespace={nsNotifRules} />;
            }
        }),
        generateColumnDefByField({
            field: notifRulesFields.BANK_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderBankCode bankCode={cell.getValue()} />
            )
        }),
        generateColumnDefByField({
            field: notifRulesFields.APPLICATION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderApplication applicationCode={cell.getValue()} />
            )
        }),
        generateColumnDefByField({
            field: notifRulesFields.EXTRA_1,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: notifRulesFields.EXTRA_2,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: notifRulesFields.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        })
    ]);
};